import { EQuizMode } from '@constants';

export const StudentQuizzesTranslations = {
  CREATE_QUIZ: {
    es: 'Crear test',
    en: 'Create test',
    cat: 'Crear prova',
    eus: 'Sortu proba',
    pt: 'Criar teste'
  },
  CREATE: {
    es: 'Crear',
    en: 'Create',
    cat: 'Crear',
    eus: 'Sortu',
    pt: 'Criar'
  },
  [EQuizMode.QUIZ]: {
    es: 'Quiz',
    en: 'Quiz',
    cat: 'Quiz',
    eus: 'Quiz',
    pt: 'Quiz'
  },
  [EQuizMode.PRACTICE]: {
    es: 'Simulacro',
    en: 'Simulator',
    cat: 'Simulacre',
    eus: 'Simulazio',
    pt: 'Simulador'
  },
  [`${EQuizMode.QUIZ}_DESCRIPTION`]: {
    es: 'Crea a tu gusto infinitos tests para practicar cuanto quieras. Selecciona los temas que quieres que aparezcan y ¡a estudiar!',
    en: 'Create your own tests to practice as much as you want. Select the topics you want to appear and start studying!',
    cat: 'Crea les teves pròpies proves per practicar tot el que vulguis. Selecciona els temes que vulguis que apareguin i comença a estudiar!',
    eus: 'Sortu zure probak nahi duzun moduan praktikatzeko. Hautatu agertu nahi dituzun gaiak eta hasi ikasten!',
    pt: 'Crie seus próprios testes para praticar o quanto você quiser. Selecione os temas que você quer que apareçam e comece a estudar!'
  },
  [`${EQuizMode.PRACTICE}_DESCRIPTION`]: {
    es: '¿Quieres probar cómo sería un examen real? Mismo tiempo y sistema de puntuación, para que llegues a la prueba preparado.',
    en: 'Do you want to try how a real exam would be? Same time and scoring system, so you arrive at the test prepared.',
    cat: 'Vols provar com seria un examen real? Mateix temps i sistema de puntuació, perquè arribis a la prova preparat.',
    eus: 'Nahi duzu proba erreal bat nola izango zen jakitea? Denbora eta puntuazio sistema berbera, proban prest heldu arte.',
    pt: 'Você quer experimentar como seria um exame real? Mesmo tempo e sistema de pontuação, para que você chegue ao teste preparado.'
  },
  DELETE_QUIZ_CONFIRMATION: {
    es: '¿Estás seguro de eliminar este test?',
    en: 'Are you sure you want to delete this test?',
    cat: "Estàs segur d'eliminar aquesta prova?",
    eus: 'Ziur zaude proba hau ezabatu nahi duzula?',
    pt: 'Você tem certeza de que deseja excluir este teste?'
  },
  EXISTING_QUESTIONS: {
    es: 'Preguntas disponibles',
    en: 'Available questions',
    cat: 'Preguntes disponibles',
    eus: 'Galderak eskuragarri',
    pt: 'Questões disponíveis'
  },
  NON_EXISTING_QUESTIONS: {
    es: 'Por favor selecciona otro curso o sección',
    en: 'Please select another course or section',
    cat: 'Per favor selecciona un altre curs o secció',
    eus: 'Mesedez hautatu beste ikastaro bat edo atala',
    pt: 'Por favor selecione outro curso ou seção'
  },
  NUMBER_OF_QUESTIONS_EXCEEDED: {
    es: 'El número de preguntas requeridas es mayor que las existentes',
    en: 'The number of required questions is greater than the existing ones',
    cat: 'El nombre de preguntes requerides és més gran que les existents',
    eus: 'Galderen kopurua eskatutakoa baino handiagoa da eskuragarriak',
    pt: 'O número de perguntas requeridas é maior que o existente'
  },
  YOUR_PROGRESS: {
    es: 'Tu progreso',
    en: 'Your progress',
    cat: 'El teu progrés',
    eus: 'Zure aurrerapena',
    pt: 'O seu progresso'
  },
  QUIZ_PROGRESS: {
    es: 'Tu progreso',
    en: 'Your progress',
    cat: 'El teu progrés',
    eus: 'Zure aurrerapena',
    pt: 'O seu progresso'
  },
  CORRECTS: {
    es: 'Aciertos',
    en: 'Corrects',
    cat: 'Encerts',
    eus: 'Zuzenak',
    pt: 'Acertos'
  },
  WRONGS: {
    es: 'Fallos',
    en: 'Wrongs',
    cat: 'Errors',
    eus: 'Akatsak',
    pt: 'Erros'
  },
  BLANKS: {
    es: 'Blancos',
    en: 'Blanks',
    cat: 'En blanc',
    eus: 'Hutsik',
    pt: 'Em branco'
  },
  TEST: {
    es: 'Test',
    en: 'Test',
    cat: 'Prova',
    eus: 'Proba',
    pt: 'Teste'
  },
  SELECT_COURSE: {
    es: 'Elige el curso',
    en: 'Choose the course',
    cat: 'Tria el curs',
    eus: 'Aukeratu ikastaroa',
    pt: 'Escolher o curso'
  },
  CANCEL: {
    es: 'Cancelar',
    en: 'Cancel',
    cat: 'Cancel·lar',
    eus: 'Ezeztatu',
    pt: 'Cancelar'
  },
  FREE_QUESTIONS_ERROR_TITLE: {
    es: 'Error al generar preguntas',
    en: 'Error generating questions',
    cat: 'Error al generar preguntes',
    eus: 'Errorea galderak sortzean',
    pt: 'Erro ao gerar perguntas'
  },
  FREE_QUESTIONS_ERROR_CONTENT: {
    es: 'Ha ocurrido un error al generar las preguntas. Por favor, inténtelo de nuevo.',
    en: 'An error has occurred while generating the questions. Please try again.',
    cat: 'Ha ocorregut un error al generar les preguntes. Si us plau, intenti-ho de nou.',
    eus: 'Errorea gertatu da galderak sortzean. Saiatu berriro, mesedez.',
    pt: 'Ocorreu um erro ao gerar as perguntas. Por favor, tente novamente.'
  },
  REVIEW_MODE_TOTAL_FAILED_QUESTIONS: {
    es: '{{total}} preguntas falladas',
    en: '{{total}} failed questions',
    cat: '{{total}} preguntes fallades',
    eus: '{{total}} galderek huts egin dira',
    pt: '{{total}} perguntas erradas'
  },
  QUIZ_HISTORY: {
    es: 'Últimos tests realizados',
    en: 'Last tests taken',
    cat: 'Últims tests realitzats',
    eus: 'Azken proben historia',
    pt: 'Últimos testes realizados'
  },
  RETAKE: {
    es: 'Repetir',
    en: 'Retake',
    cat: 'Repetir',
    eus: 'Errepikatu',
    pt: 'Repetir'
  },
  PRACTICE_WITH_TESTS_TITLE: {
    es: 'Practica lo que has aprendido',
    en: 'Practice what you have learned',
    cat: 'Practica el que has après',
    eus: 'Ikaslearen ikastarok ezagutu duenak praktikatu',
    pt: 'Pratique o que aprendeu'
  },
  SELECT_ONE_OPTION: {
    es: 'Elige una opción para evaluar tus conocimientos.',
    en: 'Choose one option to evaluate your knowledge.',
    cat: 'Tria una opció per avaluar el teu coneixement.',
    eus: 'Aukeratu batzuetan ezagutza ezagutu duzun.',
    pt: 'Escolha uma opção para avaliar o seu conhecimento.'
  },
  [`${EQuizMode.QUIZ}_MODE_TITLE`]: {
    es: 'Quiz',
    en: 'Quiz',
    cat: 'Quiz',
    eus: 'Quiz',
    pt: 'Quiz'
  },
  [`${EQuizMode.QUIZ}_MODE_DESCRIPTION`]: {
    es: 'Selecciona la respuesta correcta entre varias opciones.',
    en: 'Select the correct answer among several options.',
    cat: 'Tria la resposta correcta entre diverses opcions.',
    eus: 'Aukeratu erantzun zuzena hainbat aukeren artean.',
    pt: 'Selecione a resposta correta entre várias opções.'
  },
  [`${EQuizMode.PRACTICE}_MODE_TITLE`]: {
    es: 'Simulacro',
    en: 'Simulator',
    cat: 'Simulació',
    eus: 'Simulakro',
    pt: 'Simulador'
  },
  [`${EQuizMode.PRACTICE}_MODE_DESCRIPTION`]: {
    es: 'Enfréntate a un examen real con tiempo límite.',
    en: 'Face a a real exam with time limit.',
    cat: 'Fes frent a un examen real amb temps límit.',
    eus: 'Aurre egin benetako azterketa bati denbora muga batekin.',
    pt: 'Teste real com tempo limite.'
  },
  [`${EQuizMode.LIGHTNING}_MODE_TITLE`]: {
    es: 'Relámpago',
    en: 'Lightning',
    cat: 'Llampada',
    eus: 'Tximista',
    pt: 'Rápido'
  },
  [`${EQuizMode.LIGHTNING}_MODE_DESCRIPTION`]: {
    es: 'Acierta la mayor cantidad antes de que se acabe el tiempo.',
    en: 'Get the most before the time runs out.',
    cat: 'Aconsegueix el més abans que el temps acabi.',
    eus: 'Lortu erantzun gehien denbora agortu baino lehen.',
    pt: 'Obtenha o maior número antes de o tempo acabar.'
  },
  [`${EQuizMode.TRUE_FALSE}_MODE_TITLE`]: {
    es: 'Verdadero o falso',
    en: 'True or false',
    cat: 'Veritat o fals',
    eus: 'Egia edo gezurra',
    pt: 'Verdadeiro ou falso'
  },
  [`${EQuizMode.TRUE_FALSE}_MODE_DESCRIPTION`]: {
    es: 'Decide si las afirmaciones son ciertas o no.',
    en: 'Decide if the statements are true or false.',
    cat: 'Decide si les afirmacions són certes o no.',
    eus: 'Erabaki baieztapenak egia diren ala ez.',
    pt: 'Decida se as afirmações são verdadeiras ou falsas.'
  },
  [`${EQuizMode.PRACTICAL_CASE}_MODE_TITLE`]: {
    es: 'Supuesto práctico',
    en: 'Practical case',
    cat: 'Cas pràctic',
    eus: 'Suposizio praktikoa',
    pt: 'Caso prático'
  },
  [`${EQuizMode.PRACTICAL_CASE}_MODE_DESCRIPTION`]: {
    es: 'Responde preguntas sobre un caso práctico real.',
    en: 'Answer questions about a real practical case.',
    cat: 'Respon a preguntes sobre un cas pràctic real.',
    eus: 'Erantzun kasu praktiko erreal bati buruzko galderei.',
    pt: 'Responda perguntas sobre um caso prático real.'
  },
  FLASHCARDS_MODE_TITLE: {
    es: 'Flashcards',
    en: 'Flashcards',
    cat: 'Flashcards',
    eus: 'Flashcards',
    pt: 'Flashcards'
  },
  FLASHCARDS_MODE_DESCRIPTION: {
    es: 'Utiliza las tarjetas para repasar y memorizar conceptos.',
    en: 'Use the flashcards to review and memorize concepts.',
    cat: 'Utilitza les targetes per revisar i memoritzar conceptes.',
    eus: 'Erabili txartelak kontzeptuak berrikusteko eta memorizatzeko.',
    pt: 'Utilize as flashcards para revisar e memorizar conceitos.'
  },
  STATS: {
    es: 'Estadísticas',
    en: 'Stats',
    cat: 'Estadístiques',
    eus: 'Estatistikak',
    pt: 'Estatísticas'
  },
  VIEW_PROGRESS: {
    es: 'Ver progreso',
    en: 'View progress',
    cat: 'Veure progrés',
    eus: 'Ikusi aurrerapena',
    pt: 'Ver progresso'
  },
  QUIZZES_DONE: {
    es: 'tests realizados',
    en: 'tests taken',
    cat: 'proves realitzades',
    eus: 'probak egin dira',
    pt: 'testes realizados'
  },
  DAYS_OF_STREAK_one: {
    es: 'día de racha',
    en: 'day of streak',
    cat: 'dia de racha',
    eus: 'egun',
    pt: 'dia de racha'
  },
  DAYS_OF_STREAK_other: {
    es: 'días de racha',
    en: 'days of streak',
    cat: 'dies de racha',
    eus: 'egunak',
    pt: 'dias de racha'
  },
  OF_PRACTICE: {
    es: 'de práctica',
    en: 'of practice',
    cat: 'de pràctica',
    eus: 'praktika',
    pt: 'de prática'
  },
  TIME_SPENT: {
    es: '{{total}} horas',
    en: '{{total}} hours',
    cat: '{{total}} hores',
    eus: '{{total}} ordu',
    pt: '{{total}} horas'
  },
  LAST_7_DAYS: {
    es: 'Últimos 7 días',
    en: 'Last 7 days',
    cat: 'Últims 7 dies',
    eus: 'Azken 7 egun',
    pt: 'Últimos 7 dias'
  },
  LAST_30_DAYS: {
    es: 'Últimos 30 días',
    en: 'Last 30 days',
    cat: 'Últims 30 dies',
    eus: 'Azken 30 egun',
    pt: 'Últimos 30 dias'
  },
  LAST_365_DAYS: {
    es: 'Últimos 365 días',
    en: 'Last 365 days',
    cat: 'Últims 365 dies',
    eus: 'Azken 365 egun',
    pt: 'Últimos 365 dias'
  },
  VIEW_HISTORY: {
    es: 'Ver historial',
    en: 'View history',
    cat: 'Veure històric',
    eus: 'Ikusi historia',
    pt: 'Ver histórico'
  },
  QUIZ_EVOLUTION: {
    es: 'Tu evolución',
    en: 'Your quiz evolution',
    cat: 'Evolució de les teves proves',
    eus: 'Zure proben bilakaera',
    pt: 'Evolução dos seus testes'
  },
  QUIZ_RECOMMENDATIONS: {
    es: 'Te recomendamos practicar',
    en: 'We recommend practicing',
    cat: 'Recomanem practicar',
    eus: 'Erantzunak egin',
    pt: 'Recomendamos praticar'
  },
  VIEW_ALL: {
    es: 'Ver todos',
    en: 'View all',
    cat: 'Veure tots',
    eus: 'Ikusi guztira',
    pt: 'Ver todos'
  },
  QUIZ_RECOMMENDATIONS_DESCRIPTION: {
    es: 'Según tu práctica, estos son los cursos que necesitan refuerzo. ¡Dedícales tiempo y los dominarás!',
    en: 'According to your practice, these are the courses that need reinforcement. Dedicate time to them and you will master them!',
    cat: 'Segons el teu pràctic, aquests són els cursos que necessiten reforç. Dedica temps a ells i els dominaràs!',
    eus: 'Eskubidearen arabera, hau da, ezagutu duzun gaiak ezagutu duzun.',
    pt: 'De acordo com o seu prático, estes são os cursos que necessitam reforço. Dedique tempo a eles e dominará!'
  },
  VIEW_DETAIL: {
    es: 'Ver detalle',
    en: 'View detail',
    cat: 'Veure detall',
    eus: 'Ikusi xehetasunak',
    pt: 'Ver detalhes'
  },
  PRACTICE_COURSE: {
    es: 'Practicar',
    en: 'Practice',
    cat: 'Practicar',
    eus: 'Praktika',
    pt: 'Praticar'
  },
  COURSE_COMPLETED_QUESTIONS: {
    es: 'Has acertado <a>{{correct}} de {{total}}</a> preguntas respondidas de este curso',
    en: 'You have guessed <a>{{correct}} of {{total}}</a> questions answered from this course',
    cat: 'Has acertat <a>{{correct}} de {{total}}</a> preguntes respondides d`aquest curs',
    eus: 'Erantzun zuzena <a>{{correct}} {{total}}</a> galdera egin den kursua',
    pt: 'Você acertou <a>{{correct}} de {{total}}</a> perguntas respondidas deste curso'
  },
  VIEW_RESULTS: {
    es: 'Ver resultados',
    en: 'View results',
    cat: 'Veure resultats',
    eus: 'Ikusi emaitzak',
    pt: 'Ver resultados'
  },
  RETAKE_QUIZ: {
    es: 'Repetir test',
    en: 'Retake test',
    cat: 'Repetir test',
    eus: 'Errepikatu proba',
    pt: 'Repetir teste'
  },
  RETAKE_WRONGS: {
    es: 'Repetir incorrectas',
    en: 'Retake wrong ones',
    cat: 'Repetir incorrectes',
    eus: 'Errepikatu huts egin',
    pt: 'Repetir erradas'
  },
  CREATE_QUIZ_MODAL_TITLE: {
    es: 'Crear test',
    en: 'Create test',
    cat: 'Crear prova',
    eus: 'Sortu proba',
    pt: 'Criar teste'
  },

  RETRY_ERROR_TITLE: {
    es: 'Error',
    en: 'Error',
    cat: 'Error',
    eus: 'Errorea',
    pt: 'Erro'
  },

  RETRY_ERROR_MESSAGE: {
    es: 'Error al crear el test de repaso',
    en: 'Error creating the review test',
    cat: 'Error al crear el test de repaso',
    eus: 'Errorea egin duzu testuaren berreikin',
    pt: 'Erro ao criar o teste de revisão'
  },
  NOT_AVAILABLE_MODE: {
    es: 'Aún no hay test creados para este modo',
    en: 'There are no tests created for this mode yet',
    cat: 'Encara no hi ha proves creades per aquest mode',
    eus: 'Ez dago probak egin dira hau dela',
    pt: 'Ainda não há testes criados para este modo'
  }
};
